import React, { useContext } from 'react';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const ChatName = () => {
  const { userData } = useContext<ChatContextType>(ChatContext);
  const name = userData?.user?.username || '';

  if (!userData) return null;

  return (
    <div className={cx('nameArea')}>
      <em className={cx('title')}>닉네임</em>
      <span className={cx('name')}>{name}</span>
    </div>
  );
};

export default ChatName;
